<template>
  <main class="content-body">
    <header class="page-header">
      <h2>Zone A</h2>
    </header>
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">{{agency}}</h2>
          </header>

          <div class="panel-body">
            <div class="row">
              <div class="col-sm-9">
                <ul class="za-nav">
                  <router-link :to="{name: 'sp_tableaudebord'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href" style="white-space: nowrap"><em class="fas fa-tachometer-alt fa-spacer"></em> Tableau de bord</a>
                    </li>
                  </router-link>

                  <router-link :to="{name: 'exigences'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href" style="white-space: nowrap"><em class="fas fa-award fa-spacer"></em> Exigences</a>
                    </li>
                  </router-link>

                  <router-link :to="{name: 'dossiers'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href" style="white-space: nowrap"><em class="fas fa-archive fa-spacer"></em> Dossiers</a>
                    </li>
                  </router-link>

                  <router-link :to="{name: 'services'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href" style="white-space: nowrap"><em class="fas fa-concierge-bell fa-spacer"></em> Services</a>
                    </li>
                  </router-link>

                  <router-link :to="{name: 'contacts'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href" style="white-space: nowrap"><em class="fas fa-address-book fa-spacer"></em> Contacts</a>
                    </li>
                  </router-link>
                  
                  <router-link :to="{name: 'documents'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href" style="white-space: nowrap"><em class="fas fa-folder-open fa-spacer"></em> Documents</a>
                    </li>
                  </router-link>

                </ul>
              </div>
              <div class="col-sm-3" style="text-align:right">
                <div style="float:right;"><router-link :to="{name:'billet_creation'}" class="btn btn-primary"><i class="fa fa-plus"></i> Créer un billet</router-link></div>
              </div>
            </div>
            <div class="row" style="padding-top: 15px;">
              <div class="col-md-9 mb-md">
                <router-view :oziweb_wp_url="url_workplan" :oziweb_url="url_oziweb"></router-view>
              </div>
              <div class="col-md-3 mb-md">
                <ServiceProviderRightCol ref="right_col" :service_provider_id="$route.params.service_provider_id" :oziweb_wp_url="url_workplan" ></ServiceProviderRightCol>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import ServiceProviderRightCol from '@/components/ServiceProviderRightCol.vue';
import axios from 'axios';

export default {
  name: 'ServiceProviderTop',
  data: function() {return {
    url_workplan:'',
    url_oziweb:'',
    agency:'',
  }},

  components: {
    ServiceProviderRightCol,
  },

  methods: {

    loadServiceProvider: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_subnav.php',
          { params:{service_provider_id:this.$route.params.service_provider_id}})
        .then(response => (
          this.url_workplan = response.data.url_workplan,
          this.url_oziweb = response.data.url_oziweb,
          this.agency = response.data.agency))
    },

    refreshRightCol: function() {
      this.$refs.right_col.refresh();
    }

  },
  mounted () {
    this.loadServiceProvider();
  },
}
</script>
